import { createFeature, createReducer } from '@ngrx/store';

import { blueSageRefundDialogReducers } from './bluesage-refund-dialog.reducer';
import { blueSageRefundDialogInitialState } from './bluesage-refund-dialog.state';

export const blueSageRefundDialogFeature = createFeature({
    name: 'blueSageRefundDialog',
    reducer: createReducer(blueSageRefundDialogInitialState, ...blueSageRefundDialogReducers),
});
